<template>
  <div class="mini-cart-content new" @click="onMiniCartClick($event)">
    <template v-if="cart && cartFetched">
      <template v-if="reversedOrderedItems && cart.cartItems && cart.cartItems.length">
        <div class="summary">
            <h3>
                Your Cart
            </h3>
            <span class="subtotal">
                {{formatCurrency(cart.summary.subtotalWithSaleSavings/100)}}
            </span>
            <div @click="closeCart">
                <i class="af af-close"/>
            </div>
        </div>

        <div class="checkout-row">
          <a href="/cart" @click="onCheckOutClick($event)">
            <button class="submit button">CHECKOUT</button>
          </a>
        </div>

        <template v-if="$route.name !== 'cart'">
          <SetDiscounts :sets="setDiscounts" class="set-discounts new-mini-set-discount" :greyBackground="true" :key="`set-discount-shown-${isShown}`" />
        </template>

        <template v-for="(item, index) in reversedOrderedItems">
          <div :key="item.productId">
            <div v-if="index < maxNumItemsShown" class="row-product">

              <div class="column-image">
                <ProductBadge v-if="item.isOnSale" class="product-badge-custom" :type="'sale'" :size="'small'" />
                <ProductBadge v-else-if="item.isOnClearance" class="product-badge-custom" :type="'clearance'" :size="'small'" />
                <a :href="item.productUrl" class="mini-cart-image">
                  <ResponsiveImage :image="item.productImage" :widths="[128]"></ResponsiveImage>
                </a>
              </div>

              <div class="column-summary">
                <a class="product-name" :href="item.productUrl">
                  {{ item.productTitle }}
                  <br/>
                  <div class="price-summary"> <span v-if="item.isOnSale || item.isOnClearance">{{formatCurrency(item.originalPrice)}} </span>{{formatCurrency(item.price)}} </div>
                </a>
                <div class="qty-seleector">
                    <i class="af af-chevron-down"/>
                    <select class="small" :data-sku-no="item.productSkuNo" readonly="readonly" @change="updateItemQuantity(item, $event)">
                      <option :selected="0" key="option-0" > 0 </option>
                      <option v-for="n in 99" :key="n" :selected="item.quantity == n * item.productPackagedItemQuantity">
                        {{ n * item.productPackagedItemQuantity }}
                      </option>
                    </select>
                </div>
              </div>
            </div>
            <hr v-if="index < maxNumItemsShown - 1 && index < reversedOrderedItems.length - 1" />
          </div>
        </template>

        <div v-if="reversedOrderedItems.length > maxNumItemsShown || showAllItems" class="row-more-items">
          <hr v-if="!showAllItems "/>
          <a @click="toggleMaxItems">
            <h4 v-if="!showAllItems">Load {{ reversedOrderedItems.length - maxNumItemsShown }} more {{ (reversedOrderedItems.length - maxNumItemsShown) | itemPlural }}</h4>
          </a>
        </div>

        <div class="summary others">
            <h3>
               Others also bought
            </h3>
        </div>

        <template v-for="(item, index) in crossSellProducts">
          <div :key="item.productId">
              <div v-if="true" class="row-product" :class="{first: (index === 0) }">
              <div class="column-image">
                <ProductBadge v-if="item.isOnSale" class="product-badge-custom" :type="'sale'" :size="'small'" />
                <ProductBadge v-else-if="item.isOnClearance" class="product-badge-custom" :type="'clearance'" :size="'small'" />
                <a :href="item.productUrl" class="mini-cart-image">
                  <ResponsiveImage :image="item.productImage" :widths="[128]"></ResponsiveImage>
                </a>
              </div>
              <div class="column-summary">
                <a class="product-name" :href="item.url">
                  {{ item.title }}
                    <br/>
                   <div class="price-summary"> {{item.price}} </div>
                </a>

                <AddToCartButton
                    :products="parseProduct(item)"
                    :button-classes="['outlined', 'coral']"
                    :scroll-first="false"
                    class="add-to-cart-toggle"
                    :animate="true"
                    :show-loader="true"
                    @beforeAdded="onProductAddedToCart" >

                    <i class="af af-plus"/>
                    <i class="af af-cart"/>

                </AddToCartButton>

              </div>
            </div>
            <hr />
          </div>
        </template>

      </template>
      <div v-else class="no-item-message">

        <div class="summary">
            <h3>
                Your Cart
            </h3>

            <div @click="closeCart">
                <i class="af af-close"/>
            </div>
        </div>

        <h5>

          Your cart is empty.
        </h5>

        <div class="checkout-row">
          <a href="#" @click="closeCart($event)">
            <button class="submit button">CONTINUE SHOPPING</button>
          </a>
        </div>

      </div>
    </template>
    <div v-else class="loading">
      <div class="loader large"></div>
      <h4>Loading</h4>
    </div>
  </div>
</template>

<script>
import ProductBadge from '@/components/commons/ProductBadge.vue';
import { Image as ResponsiveImage } from '@article/pixel';
import SetDiscounts from './SetDiscounts.vue';
import CrossSell from '@/components/commons/CrossSell.vue';
import AddToCartButton from '@/components/commons/AddToCartButton.vue';
import useCrossSell from '@/compositions/useCrossSell.js';
import CountryUtils from '@/components/commons/CountryUtils.js';
import LocationService from '@/services/LocationService';
import Tracking from '@/components/commons/Tracking.js';

import {
  mapState, //
  mapActions,
  mapMutations,
  mapGetters,
} from 'vuex';

export default {
  name: 'MiniCart',
  components: {
    AddToCartButton,
    ProductBadge,
    CrossSell,
    SetDiscounts,
    ResponsiveImage,
  },

  filters: {
    itemPlural(value) {
      if (value === null) {
        return 'items';
      }
      if (value === 1) {
        return 'item';
      }
      return 'items';
    },
  },
  props: {
    cart: Object,
    isShown: Boolean,
    cartFetched: Boolean,
  },

  data() {
    return {
      showAllItems: false,
      maxNumItemsShown: 3,
      isCartClicked: false,
      crossSellProducts: []
    };
  },

  beforeMount() {
  },

  mounted() {
  },

  watch: {
    reversedOrderedItems() {
      this.loadCrossSellProducts()
    }
  },

  computed: {
    reversedOrderedItems() {
      let items = [];
      if (this.cart.summary && this.cart.summary.items) {
        items = [...this.cart.summary.items];
      } else if (this.cart.orderInfos && this.cart.orderInfos.length) {
        items = this.cart.orderInfos.reduce((acc, orderInfo) => [...acc, ...orderInfo.items], []);
      }

      items.reverse();

      return items;
    },

    setDiscounts() {
      if (this.cart && this.cart.summary && this.cart.summary.discounts) {
        return this.cart.summary.discounts.filter((x) => typeof x.setDiscountId !== 'undefined');
      }
      return [];
    },

    currentPage() {
      return window.location.pathname;
    },
  },

  methods: {
    ...mapActions('common', [
      'openMiniCart',
      'miniCartUpdateQuantity'
    ]),

    updateItemQuantity(item, e) {
      this.miniCartUpdateQuantity({
        productId: item.productId,
        quantity: e.target.value,
      }).then(() => {
        this.openMiniCart()
      })

      Tracking.track('mini_cart_quantity_change', { product_id: item.productId, old_quantity: item.quantity, new_quantity: e.target.value });
    },

    formatCurrency(amount) {
      const formatter = new Intl.NumberFormat('en-US');

      const currencyPrefix = CountryUtils.getCountryByCurrencyId(LocationService.getCurrencyId()).currencySymbol;
      return `${currencyPrefix}${formatter.format(amount)}`;
    },

    async loadCrossSellProducts() {
      this.crossSellProducts = []
      const { crossSellProducts, fetchCrossSellProducts } = useCrossSell();
      const data = await fetchCrossSellProducts(this.reversedOrderedItems.map((x) => x.productId))
      this.crossSellProducts = data.slice(0, 3)
    },

    toggleMaxItems() {
      if(this.showAllItems) {
        this.maxNumItemsShown = 3
        this.showAllItems = false
      }else{
        this.maxNumItemsShown = this.reversedOrderedItems.length + 1
        this.showAllItems = true
      }
    },

    onProductAddedToCart(products) {
      Tracking.track('mini_cart_carousel_product_added', { product_id: products[0].id });
      document.querySelector('.mini-cart-content').scrollTo({ behavior: 'smooth', top: 0 });

      if (this.$root.$options.router?.history?.current?.path.indexOf('/product/') == -1) {
        this.$nextTick(() => { this.openMiniCart() })
      }
    },

    parseProduct(product) {
      return [{ id: product.id, quantity: product.packagedItemQuantity }];
    },

    onMiniCartClick(event) {
      event.stopPropagation();
    },

    onCheckOutClick(event) {
      this.$emit('checkout');
    },
    closeCart(event) {
      event.preventDefault();
      this.$emit('closeMiniCart');
    },
  },
};
</script>

<style lang="scss">
@import '~@article/pixel/dist/style/variables';
@import '~@article/pixel/dist/style/mixins';

.mini-cart-content.new {
  z-index: 6;
  width: 370px;
  background: white;
  @include overlay();
  height: 100vh;
  overflow-y: scroll;
  &::-webkit-scrollbar { display: none; }
  &::-moz-scrollbar { display: none; }
  &::-ms-scrollbar { display: none; }

   .subtotal{ padding-top: 1px; }

  .summary{
    width: calc(100% - var(--space-4)*2);
    box-sizing: border-box;
    display: flex;
    padding: var(--space-4) 0;
    margin: 0 var(--space-4);
    justify-content: start;
    flex-direction: row;
    &.others{
        border-top: 4px solid var(--grey-ultra-light);
        padding-top: var(--space-6);
        padding-bottom: 0;
        margin-bottom: 16px;
    }

    div{
        cursor: pointer;
        margin-left: auto;
    }

    h3{
        text-transform: none;
        padding-right: var(--space-4);
        letter-spacing: normal;
    }
  }

  .checkout-row{
    height: 30px;
    width: auto;
    margin: var(--space-4);
    margin-top: 0;
    margin-bottom: 24px;

    a, button{
        display: block;
        width: 100%;
    }
  }

  @media (max-width: $mobile-breakpoint - 1) {
    width: 100vw;
  }

  .row {
    &:after {
      content: none;
    }
  }

  h4 {
    line-height: 1em;
    font-size: var(--font-size-14);
    width: 100%;
  }

  hr {
    margin: 0.5em auto;
    width: calc(100% - 48px);
    @media (max-width: $tablet-breakpoint - 1) {
      width: calc(100% - 24px);
    }
    border-color: var(--grey-ultra-light);
  }

  .row-product {
    display: flex;
    position: relative;
    margin: var(--space-4) 0;
    min-height: 90px;
    &.first{
        margin-top: 0;
    }

    .column-image {
      display: inherit;
      flex: 2;
      align-items: center;
      justify-content: center;
      padding: 0;
      margin-left: var(--space-4);

      .sale-tag {
        background-color: var(--accent-color);
        width: 18px;
        height: 18px;
        position: absolute;
        z-index: 2;
        border-radius: 25px;
        top: 12px;
        left: 25px;
        color: var(--white);
        p {
          font-size: 6px;
          margin-left: 2px;
          margin-top: 5px;
          line-height: 9px;
        }

        @media (max-width: $mobile-breakpoint - 1) {
          left: 14px;
        }
      }
    }
    .column-summary {
      display: flex;
      flex: 4;
      flex-direction: row;
      text-align: left;
      align-items: center;
      justify-content: space-between;
      padding: 0;
      padding-left: 4px;
      padding-right: 16px;

      a{
          width: 90%;
          padding-right: 10px;
      }

      .add-to-cart-toggle{
        display: flex;
        justify-content: center;
        height: 24px;
        padding: 0;
        .add-to-cart-loader{
            padding: 4px 10px;
            min-width: 54px;
        }
        button{
            padding: 4px 10px;
            max-height: 26px;

        }

        i{
            display: inline-block;
            height: 100%;
            width: auto;
            text-align: center;
            vertical-align: middle;
            color: var(--coral);
            font-size: var(--font-size-12);
        }

      }

      .qty-seleector{
        position: relative;

        .small{
            width: auto;
            padding-right: 20px;
            font-size: 16px;
        }

        i{
            position: absolute;
            padding: 0;
            margin: 0;
            top: 0px;
            right: 8px;
            display: inline-block;
            vertical-align: middle;
            z-index: 3;
            pointer-events: none;
            font-size: var(--font-size-14);
        }
      }

      .product-name {
        display: block;
        text-transform: none;
        font-family: var(--font-regular);
        color: var(--font-color);
        .price-summary{
            font-family: var(--font-bold);
            color: var(--coral);
            span{
                text-decoration: line-through;
                font-family: var(--font-regular);
                color: var(--font-color);
            }
        }
      }

      .row {
        display: inherit;
        @media (min-width: $tablet-breakpoint) {
          .quantity {
            p {
              line-height: normal;
              margin-top: var(--space-2);
              text-align: left;
              margin-right: 32px;
            }
          }
        }
        @media (max-width: $tablet-breakpoint - 1) {
          justify-content: space-between;
        }

        p {
          font-size: var(--font-size-14);
          margin: 0;
        }
      }
    }
  }

  .row-more-items {
    text-align: center;
    h4{
      display: inline-block;
      width: auto;
      margin-bottom: var(--space-4);
      color: var(--grey-medium);
      border-bottom: 1px solid var(--grey-light);
      text-transform: none;
      letter-spacing: unset;
    }
    h3 {
      text-transform: uppercase;
      font-size: 0.7em;
      font-weight: 500;
      color: var(--grey-medium);
      margin: 12px 0;
    }
  }

  .row-checkout {
    display: flex;
    justify-content: center;
    background-color: var(--grey-ultra-light);

    @media (min-width: $tablet-breakpoint - 1) {
      margin-top: var(--space-2);
    }
  }

  .row-set {
    margin: var(--space-4) 0;
    &.collapse-top {
      margin-top: var(--space-2);
    }
    @media (max-width: $mobile-breakpoint - 1) {
      width: calc(100vw - 48px);
      margin: {
        left: auto;
        right: auto;
      }
    }
  }
  .mini-cart-button {
    margin: var(--space-4) var(--space-2);
  }

  .product-badge-custom {
    margin-left: 15px;
  }

  .mini-cart-image {
    width: 128px;
    min-height: 66px;
  }

  .no-item-message {
    padding: 0;
    text-align: center;

    h5 {
      font-size: 16px;
      margin-top: var(--space-10);
      letter-spacing: normal;
      margin-bottom: var(--space-6);
      font-family: var(--font-regular);
      text-transform: none;
    }
  }

  .loading {
    text-align: center;
    padding: 32px 0;
    .loader {
      margin-bottom: 12px;
    }
  }

  .set-discounts.new-mini-set-discount {
      padding: 0;
      .set-discount.set-discount-grey{
          padding: var(--space-4);
          background-color: transparent;
          border-bottom: 1px solid var(--grey-ultra-light);
      }
  }
}
</style>
